/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Title } from '@insticator/insticator-ui';
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import SectionCard from '../../../../../material/expandablesection/sectioncard/sectioncard';
// content
import ExportBox from './exportbox/exportbox';
// styles
import injectSheet from "react-jss";
import styles from './export_styles.js';
import { exportCommentingData } from '../../../../../state/thunks/commenting';

/* ========== ~~~~~~~~~~ COMMENTING ADVANCED: EXPORT SECTION ~~~~~~~~~~ ========== */
const CommentingExportSection = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const commentingUnitUUID = useSelector(state => state.commenting.commentingConfig?.data?.commentingUnitUUID)
  const [isFileExporting, setFileExporting] = useState({fileType: null, exporting: false})
  const [isOpened, setIsOpened] = useState(false);

  const csvMessages = [
      `Comma Separated Values (CSV) is a format that stores table and spreadsheet information. 
      The content is text, numbers, and dates in plain text. 
      Each line represents a row of the table, and commas separate the cells in a row.`,
      'CSV files can be opened by any spreadsheet program: Microsoft Excel, Open Office, Google Spreadsheets, etc. You can open a CSV file in a simple text editor as well.'
  ];
  const xmlMessages = [
      `Extensible Markup Language (XML) is a format that stores and describes information in plain text with custom tags. XML files are reader-friendly, with a clear focus on use and exchange on the Internet and on corporate networks.`,
      'XML files can be opened by any web browser for viewing structured data or by Notepad for editing.'
  ];
  const applyTipMessages = (messages) => {
      return (
          <div className={'csvToolTip'}>
              <span>{messages[0]}</span>
              <br /><br />
              <span>{messages[1]}</span>
          </div>
      );
  }
  const handleExport = useCallback(async(fileType) => {
    setFileExporting({fileType, exporting: true})
    const response =  await dispatch(exportCommentingData({commentingUnitUUID, format: fileType}))
    setFileExporting({fileType: null, exporting: false})
  },[dispatch, commentingUnitUUID])

  const handleToggle = () => setIsOpened(!isOpened) 

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleToggle}
      isOpened={isOpened}
      configTitle={'View'}
      cancelTitle={'Close'}
      title='Export User Data'
    />
  );
  
  return (
    <ExpandableSection
      className={`commentingexportsection ${props.classes.commentingexportsection}`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleToggle}
      cancelTitle={'Close'}
    >
    {isOpened && 
    <SectionCard>
      <div className={`export ${props.classes.export}`}>
        <div className={'header'}>
          <Title><h3>Export user data as a CSV or XML</h3></Title>
          <p>Export includes <strong>user profile data</strong> (name, email, location) and <strong>user activity data</strong> (sign-up date, last login, etc.).</p>
        </div>
        <ExportBox image={'illustration-csv.png'} title={'Comma Separated Values'} value={`CSV`}
            subdescription={'Tabular format (Microsoft Excel, Google Spreadsheets, etc.).'} 
            buttontext={'Export as CSV'} 
            processing={isFileExporting.fileType === 'CSV' && isFileExporting.exporting}
            tipcontent={applyTipMessages(csvMessages)}
            handleExport={handleExport}/>
        <ExportBox image={'illustration-xml.png'} title={'Extensible Markup Language'} value={`XML`}
            subdescription={'Internet format (Web browsers, Notepad, etc.).'} 
            buttontext={'Export as XML'} 
            processing={isFileExporting.fileType === 'XML' && isFileExporting.exporting}
            tipcontent={applyTipMessages(xmlMessages)}
            handleExport={handleExport}/>
      </div>
    </SectionCard>
    }
    </ExpandableSection>
  );
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingExportSection